/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Return_ApproveInputs */

const vi_carrier_return_approve = /** @type {(inputs: Carrier_Return_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt chuyển hoàn`)
};

/**

* @param {Carrier_Return_ApproveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_return_approve = /** @type {((inputs?: Carrier_Return_ApproveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Return_ApproveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_return_approve(inputs)
});